const PrivacyPolicyData = [
  {
    id: "introduction",
    title: "Introduction",
    content: [
      "Welcome to KodeVedic, a digital learning platform operated by JoinSPAF, a registered NGO based in Gondia, Maharashtra, India. We are committed to protecting your personal information and your right to privacy.",
      'This Privacy Policy describes how KodeVedic ("we", "us", or "our") collects, uses, stores, and shares information when you use our website at kodevedic.com, our mobile applications, and related services (collectively, the "Platform").',
      "By using our Platform, you agree to the collection and use of information in accordance with this policy. If you do not agree, please discontinue use of the Platform.",
    ],
  },
  {
    id: "information-we-collect",
    title: "Information We Collect",
    content: [
      "Account Information: When you register, we collect your first name, last name, email address, and a password. You may optionally provide a profile picture and a brief bio.",
      "Payment Information: When you purchase a course, payment is processed by Razorpay, our payment partner. We do not store your full card number, CVV, or bank credentials. We receive a transaction ID and basic purchase metadata to fulfil your order.",
      "Course Activity: We collect data about which courses you enrol in, your progress through course content (sections completed, videos watched), quiz attempts, and completion status.",
      "Communications: If you contact us via email or through our Contact page, we retain records of that correspondence including your name, email address, and message content.",
      "Technical Data: We automatically collect standard log data including your IP address, browser type and version, time zone, operating system, and pages visited on our Platform. This helps us maintain security and improve performance.",
    ],
  },
  {
    id: "how-we-use-your-information",
    title: "How We Use Your Information",
    content: [
      "Account Management: To create and maintain your account, authenticate your identity, and allow you to access purchased courses.",
      "Order Fulfilment: To process payments, issue course access, and send you order confirmation and receipts.",
      "Learning Experience: To track your progress, issue certificates of completion, and recommend relevant courses based on your enrolment history.",
      "Customer Support: To respond to your queries, troubleshoot problems, and resolve disputes.",
      "Platform Improvement: To analyse usage patterns, identify technical issues, and improve the design and functionality of the Platform.",
      "Communications: To send you service-related notices (e.g., password resets, policy updates). With your consent, we may also send promotional emails about new courses or offers. You can unsubscribe at any time.",
    ],
  },
  {
    id: "information-sharing",
    title: "Information Sharing",
    content: [
      "We do not sell, rent, or trade your personal information to third parties for their marketing purposes.",
      "Payment Processor: We share necessary transaction details with Razorpay to process course purchases. Razorpay's use of your data is governed by their own Privacy Policy.",
      "Service Providers: We may share data with trusted service providers who assist us in operating the Platform (e.g., cloud hosting, email delivery). These providers are contractually bound to keep your data confidential and use it only to perform services on our behalf.",
      "Legal Obligations: We may disclose your information if required by law, court order, or governmental authority, or if we believe disclosure is necessary to protect the rights, property, or safety of KodeVedic, our users, or others.",
      "Business Transfers: If KodeVedic is acquired, merged, or undergoes a similar transaction, your information may be transferred as part of that transaction. We will notify you before your data is transferred and becomes subject to a different privacy policy.",
    ],
  },
  {
    id: "cookies",
    title: "Cookies and Tracking",
    content: [
      "We use cookies and similar technologies to maintain your login session, remember your preferences, and analyse Platform usage.",
      "Essential Cookies: Required for the Platform to function. They keep you logged in and secure your session.",
      "Analytics Cookies: Help us understand how visitors interact with our Platform so we can improve it. These do not identify you personally.",
      "You can control cookie settings through your browser. Please note that disabling essential cookies will prevent you from logging in and accessing your courses. See our Cookie Policy for full details.",
    ],
  },
  {
    id: "data-security",
    title: "Data Security",
    content: [
      "We implement industry-standard security measures including HTTPS encryption, hashed password storage, and access controls to protect your personal data against unauthorised access, alteration, disclosure, or destruction.",
      "While we strive to protect your data, no method of internet transmission or electronic storage is 100% secure. We cannot guarantee absolute security, but we take all reasonable steps to protect your information.",
      "If you suspect your account has been compromised, please change your password immediately and contact us at connect@kodevedic.com.",
    ],
  },
  {
    id: "your-rights",
    title: "Your Rights",
    content: [
      "Access: You have the right to request a copy of the personal data we hold about you.",
      "Correction: You can update your profile information at any time through your account settings. If you need to correct other data, contact us.",
      "Deletion: You may request deletion of your account and personal data. Note that we may retain certain transaction records for legal and tax compliance purposes.",
      "Data Portability: You may request an export of your personal data in a machine-readable format.",
      "Withdraw Consent: If we process your data based on consent (e.g., marketing emails), you may withdraw that consent at any time without affecting the lawfulness of prior processing.",
      "To exercise these rights, email us at connect@kodevedic.com with the subject line 'Privacy Request'.",
    ],
  },
  {
    id: "data-retention",
    title: "Data Retention",
    content: [
      "We retain your account data for as long as your account is active or as needed to provide you services.",
      "If you delete your account, we will delete or anonymise your personal data within 30 days, except where retention is required by applicable law (e.g., financial records which we keep for 7 years as required under Indian tax regulations).",
      "Course progress and completion data are retained for the duration of the platform's operation to enable you to demonstrate your learning history.",
    ],
  },
  {
    id: "changes",
    title: "Changes to This Policy",
    content: [
      "We may update this Privacy Policy from time to time. We will notify you of significant changes by posting a notice on the Platform or by sending an email to the address on file.",
      "Your continued use of the Platform after changes are posted constitutes your acceptance of the updated policy. We encourage you to review this policy periodically.",
    ],
  },
  {
    id: "contact",
    title: "Contact Us",
    content: [
      "If you have questions, concerns, or requests regarding this Privacy Policy or the handling of your personal data, please contact our Grievance Officer:",
      "Email: connect@kodevedic.com",
      "Address: KodeVedic / JoinSPAF, RICECITY, Near ZP School, Fulchur, Gondia, Maharashtra – 441601, India.",
      "We will respond to your query within 7 business days.",
    ],
  },
];

export default PrivacyPolicyData;
